<template>
  <div class="horizontal-scroll-hint">
    <div class="horizontal-scroll-hint__icon">
      <svg
        width="62"
        height="131"
        viewBox="0 0 62 131"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.51227 89.7169C5.51227 91.2375 6.74777 92.378 8.17336 92.378L11.3347 97.7952H8.17336C3.70652 97.7952 0 94.1837 0 89.6218V8.17336C0 3.70652 3.70652 0 8.17336 0H45.2386C49.7054 0 53.412 3.61149 53.412 8.17336V83.7895C53.412 83.9795 53.2219 84.0746 53.1268 84.0746H48.0898C47.8997 84.0746 47.8047 83.8845 47.8047 83.7895V8.17336C47.8047 6.65274 46.5691 5.51227 45.1436 5.51227H40.6767C40.5817 5.51227 40.5817 5.60731 40.5817 5.60731V6.84281C40.5817 7.7932 39.8214 8.64856 38.7759 8.64856H14.541C13.5906 8.64856 12.7352 7.88824 12.7352 6.84281V5.60731C12.7352 5.51227 12.6402 5.51227 12.6402 5.51227H8.17336C6.65274 5.51227 5.51227 6.74777 5.51227 8.17336V89.7169Z"
          fill="#BDBDBD"
          fill-opacity="0.8"
        />
        <path
          d="M55.2977 83.3214C53.949 83.3214 52.8026 83.6586 51.7911 84.2655C50.7121 81.9727 48.4193 80.4216 45.7892 80.4216C44.4405 80.4216 43.2941 80.7588 42.2826 81.3657C41.2036 79.0729 38.9108 77.5219 36.2808 77.5219C35.3366 77.5219 34.2577 77.7916 33.381 78.1288V60.1908C33.381 56.4818 30.4138 53.5821 26.7723 53.5821C23.1307 53.5821 20.1635 56.5493 20.1635 60.1908V90.1324L18.1404 85.9514C17.1963 83.4563 14.6338 81.6355 11.9363 81.6355C11.1945 81.6355 10.3853 81.7704 9.64349 81.9727C8.09245 82.5796 6.74373 83.7934 6.06937 85.4793C5.32757 87.0304 5.26014 88.8511 5.79963 90.537C5.79963 90.537 5.79963 90.6719 5.9345 90.6719L19.6915 119.872C19.6915 120.007 19.8263 120.007 19.8263 120.141C21.2425 122.299 22.9284 124.188 24.9515 125.874C25.0864 126.008 25.2212 126.008 25.2887 126.143C25.4235 126.278 25.4235 126.278 25.5584 126.413C29.5371 129.313 34.1902 130.864 39.1131 130.864C51.319 130.864 61.367 121.288 61.9065 109.149C61.9065 109.149 61.9065 109.015 61.9065 108.88C61.9065 108.542 61.9065 108.138 61.9065 107.801C61.9065 107.666 61.9065 107.666 61.9065 107.531V107.261C61.9065 106.991 61.9065 106.924 61.9065 106.654V89.8627C61.9739 86.2886 59.0067 83.3214 55.2977 83.3214ZM39.1131 127.02C35.0669 127.02 31.223 125.806 27.9861 123.446L27.7164 123.176C27.4466 122.906 27.2443 122.839 26.9746 122.704C25.4235 121.355 24.0748 119.939 22.9958 118.253L9.3063 89.2558C9.03656 88.514 9.03656 87.8396 9.44118 87.0978C9.77836 86.356 10.2504 85.884 10.9922 85.6816C12.4084 85.2096 14.0943 85.9514 14.5663 87.3676C14.5663 87.3676 14.5663 87.5024 14.7012 87.5024L20.4333 99.4386C20.7704 100.248 21.782 100.652 22.5912 100.518C23.4005 100.248 24.0074 99.5735 24.0074 98.6968V60.1908C24.0074 58.6398 25.3561 57.291 26.9071 57.291C28.4582 57.291 29.8069 58.6398 29.8069 60.1908V84.1306C29.8069 85.2096 30.6161 86.0188 31.6951 86.0188C32.7741 86.0188 33.5833 85.2096 33.5833 84.1306C33.5833 82.5796 34.932 81.2309 36.4831 81.2309C38.0341 81.2309 39.3828 82.5796 39.3828 84.1306V87.0304C39.3828 88.1093 40.192 88.9186 41.271 88.9186C42.35 88.9186 43.1592 88.1093 43.1592 87.0304C43.1592 85.4793 44.508 84.1306 46.059 84.1306C47.61 84.1306 48.9587 85.4793 48.9587 87.0304V89.9301C48.9587 91.0091 49.768 91.8183 50.847 91.8183C51.9259 91.8183 52.7352 91.0091 52.7352 89.9301C52.7352 88.3791 54.0839 87.0304 55.6349 87.0304C57.1859 87.0304 58.5347 88.3791 58.5347 89.9301V107.059V107.531C58.5347 107.801 58.5347 107.868 58.5347 108.138C58.5347 108.475 58.5347 108.745 58.5347 109.082C57.5906 119.13 49.2959 127.02 39.1131 127.02Z"
          fill="white"
        />
        <path
          d="M15.8475 61H6.40649L8.56445 58.842C9.30624 58.1003 9.30624 56.9538 8.56445 56.212C7.82265 55.4702 6.67624 55.4702 5.93444 56.212L0.53955 61.6069C0.269805 61.8767 0.202369 61.9441 0.202369 62.2139C-0.0673751 62.6859 -0.0673751 63.158 0.202369 63.63C0.337242 63.8998 0.472114 64.1021 0.53955 64.2369L5.93444 69.6318C6.27162 69.969 6.74367 70.2387 7.28316 70.2387C7.82265 70.2387 8.22727 69.969 8.63188 69.6318C9.37368 68.89 9.37368 67.7436 8.63188 67.0018L6.47393 64.8439H15.915C16.994 64.8439 17.8032 64.0346 17.8032 62.9557C17.8032 61.8767 16.9265 61 15.8475 61Z"
          fill="white"
        />
        <path
          d="M53.7468 62.2139C53.6119 61.9441 53.477 61.7418 53.4096 61.6069L48.0147 56.212C47.2729 55.4702 46.1265 55.4702 45.3847 56.212C44.6429 56.9538 44.6429 58.1003 45.3847 58.842L47.5426 61H38.1016C37.0226 61 36.2134 61.8092 36.2134 62.8882C36.2134 63.9672 37.0226 64.7764 38.1016 64.7764H47.4752L45.3172 66.9344C44.5755 67.6762 44.5755 68.8226 45.3172 69.5644C45.6544 69.9016 46.1265 70.1713 46.666 70.1713C47.138 70.1713 47.6101 69.9016 48.0147 69.5644L53.4096 64.1695C53.6793 63.8998 53.7468 63.8323 53.7468 63.5626C53.8816 63.158 53.8816 62.6859 53.7468 62.2139Z"
          fill="white"
        />
      </svg>
    </div>
    <i18n
      tag="h2"
      path="hints.horizontalScroll.title"
      class="horizontal-scroll-hint__title"
    >
      <template #requiredAction>
        <strong>{{ $t('hints.horizontalScroll.requiredAction') }}</strong>
      </template>
    </i18n>
  </div>
</template>

<script>
export default {
  name: 'HorizontalScrollHint',
  data() {
    return {
      hintCloseTimeout: null,
    }
  },
}
</script>

<style lang="scss" scoped>
.horizontal-scroll-hint {
  text-align: center;

  @at-root #{&}__title {
    font-size: 1.0625rem;
    font-weight: var(--font-weight-regular);
    line-height: 1.172;
    color: var(--white);
    padding: 0;
    margin: 24px 0 10px;
    strong {
      font-size: 1.125rem;
      font-weight: var(--font-weight-medium);
    }
  }
}
</style>
